<template>
  <el-submenu class="avatar-menu" index="2">
    <template slot="title">
      <div class="avatar">
        <img v-if="$store.state.user.avatar" :src="$store.state.user.avatar | ossImageUrl" class="user-avatar">
        <svg-icon v-else icon-class="admin" class-name="user-avatar"/>
        {{ $store.state.user.name }}
      </div>
    </template>

    <el-menu-item index="2-1">
      <router-link class="inlineBlock" to="/my-account">
        <el-dropdown-item>
          我的帐户
        </el-dropdown-item>
      </router-link>
    </el-menu-item>
    <el-menu-item index="2-2">
      <el-dropdown-item>
        <span style="display:block;" @click="logout">登出</span>
      </el-dropdown-item>
    </el-menu-item>

  </el-submenu>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'avatar'
    ])
  },
  methods: {
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    }
  }
}
</script>

<style lang="scss">
.avatar-menu {
  &.el-submenu .el-submenu__title {
    height:50px !important;
    line-height:50px !important;
    border-width:0;
    padding:0 15px;
  }
  .el-submenu__title:hover {
    background-color: transparent !important;
  }
  .el-submenu__title:hover .avatar {
    color:#ccc;
  }
}
.avatar-menu .avatar {
  color:#fff !important;
  > img {
    width:30px;
    height:30px;
    border-radius:15px;
    color:#fff;
  }
}
.user-avatar {
  font-size:20px;
}
</style>
